import { RouteObject, Navigate, useSearchParams, useParams } from 'react-router-dom';
import { lazy } from 'react';

// eslint-disable-next-line react-refresh/only-export-components
function HospedagensRedirect() {
  const [searchParams] = useSearchParams();
  const to = `/buscar${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
  return <Navigate to={to} replace />;
}

// eslint-disable-next-line react-refresh/only-export-components
function HospedagemRedirect() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const to = `/property/${id}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
  return <Navigate to={to} replace />;
}

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const City = lazy(() => import('../pages/city/page'));
const Buscar = lazy(() => import('../pages/buscar/page'));
const Property = lazy(() => import('../pages/property/page'));
const Book = lazy(() => import('../pages/book/page'));
const BookingConfirmation = lazy(() => import('../pages/booking-confirmation/page'));
const Eventos = lazy(() => import('../pages/eventos/page'));
const GruposEAgencias = lazy(() => import('../pages/grupos-e-agencias/page'));
const OndeIr = lazy(() => import('../pages/onde-ir/page'));
const Restaurantes = lazy(() => import('../pages/restaurantes/page'));
const RestauranteDetalhes = lazy(() => import('../pages/restaurante-detalhes/page'));
const Sobre = lazy(() => import('../pages/sobre/page'));
const Experiencias = lazy(() => import('../pages/experiencias/page'));
const Termos = lazy(() => import('../pages/termos/page'));
const PoliticaDePrivacidade = lazy(() => import('../pages/politica-de-privacidade/page'));
const CancelamentoEReembolso = lazy(() => import('../pages/cancelamento-e-reembolso/page'));
const PoliticaDeCookies = lazy(() => import('../pages/politica-de-cookies/page'));
const Contato = lazy(() => import('../pages/contato/page'));
const Planejar = lazy(() => import('../pages/planejar/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/experiencias',
    element: <Experiencias />,
  },
  {
    path: '/termos',
    element: <Termos />,
  },
  {
    path: '/politica-de-privacidade',
    element: <PoliticaDePrivacidade />,
  },
  {
    path: '/cancelamento-e-reembolso',
    element: <CancelamentoEReembolso />,
  },
  {
    path: '/politica-de-cookies',
    element: <PoliticaDeCookies />,
  },
  {
    path: '/contato',
    element: <Contato />,
  },
  {
    path: '/planejar',
    element: <Planejar />,
  },
  {
    path: '/planejar/:token',
    element: <Planejar />,
  },
  {
    path: '/city',
    element: <City />,
  },
  {
    path: '/buscar',
    element: <Buscar />,
  },
  {
    path: '/hospedagens',
    element: <HospedagensRedirect />,
  },
  {
    path: '/property/:slug',
    element: <Property />,
  },
  {
    path: '/book/:slug',
    element: <Book />,
  },
  {
    path: '/booking/confirmation/:id',
    element: <BookingConfirmation />,
  },
  {
    path: '/hospedagem/:id',
    element: <HospedagemRedirect />,
  },
  {
    path: '/eventos',
    element: <Eventos />,
  },
  {
    path: '/grupos-e-agencias',
    element: <GruposEAgencias />,
  },
  {
    path: '/onde-ir',
    element: <OndeIr />,
  },
  {
    path: '/restaurantes',
    element: <Restaurantes />,
  },
  {
    path: '/restaurante/:id',
    element: <RestauranteDetalhes />,
  },
  {
    path: '/sobre',
    element: <Sobre />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
